export class Address {
    constructor(address, postalCode, city) {
        this.address = address;
        this.postalCode = postalCode;
        this.city = city;
    }
    get fullAddress() {
        return this.address + (this.postalCode ? ', ' + this.postalCode : '') + (this.city ? ', ' + this.city : '');
    }
}
//# sourceMappingURL=Address.js.map